import { useContext } from 'react';

import {
  UserAuthorizationsContext,
  type UserAuthorizationsContextType,
} from '@/contexts/user-authorizations/UserAuthorizationsContext';

export const useUserAuthorizations = (): UserAuthorizationsContextType => {
  const context = useContext(UserAuthorizationsContext);

  if (context === undefined) {
    throw new Error('useUserAuthorizations must be used within a UserAuthorizationsProvider');
  }

  return context;
};
